export const ActivitySolicitation =
{
    path: "/ActivitySolicitation",
    component: () => import("@/views/ActivitySolicitation/index"),
    meta: {
        hidden: true,
    },
}

export const activityDescription =
{
    path: "/activityDescription",
    component: () => import("@/views/ActivitySolicitation/activityDescription"),
    meta: {
        hidden: true,
    },
}
export const activityDescriptionEnd =
{
    path: "/activityDescriptionEnd",
    component: () => import("@/views/ActivitySolicitation/end"),
    meta: {
        hidden: true,
    },
}